export enum ApplicableCourt {
    GET_APPLICABLE_COURT = 'GET_APPLICABLE_COURT',
    GET_APPLICABLE_COURT_SUCCESS = 'GET_APPLICABLE_COURT_SUCCESS',
    GET_APPLICABLE_COURT_FAIL = 'GET_APPLICABLE_COURT_FAIL',
}